import * as mathUtil from '@/common/js/mathutil.js'

import Decimal from '@/math/types/decimal.js'
import Equation from '@/math/types/equation.js'

export default {
  title: 'Divide by 5',
  operation: 'arithmetic-integer',
  instruction: 'Divide.',
  config: { nProblems: 10, maxPlaces: 2, displayMode: 'horizontal' },
  equation: function () {
    var lhs = new Decimal(5)
    var rhs = new Decimal(mathUtil.randomIntUniform(1, 9))

    return new Equation('÷', lhs.mul(rhs), lhs, rhs)
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/div/divzmtg.js